/**
 * main.js — the client's single entry point (Vite bundles from here).
 *
 * client.js is the game; it wires every other module through imports. This
 * file exists so index.html has exactly one <script type="module"> and so the
 * handful of things that must be reachable from the browser console are
 * exposed on window in one visible place instead of scattered `window.X = X`
 * lines. Modules that only have side effects (auth UI) are imported here too.
 */
import { ClientLogger } from './logger/ClientLogger.js';
import { setSharedLoggerFactory } from '../shared/utils/loggerProxy.js';
import { Auth } from './auth.js'; // sets up the login UI on DOM ready
import './client.js';

// shared/ code logs through the client logger
setSharedLoggerFactory((category) => ClientLogger.getLogger(category.toLowerCase()));

// Console conveniences (documented in docs/guides/development-tools.md)
window.ClientLogger = ClientLogger;
window.Auth = Auth;

// Dev-only console helper (window.containerDebug); tree-shaken out of production builds
if (import.meta.env?.DEV) {
  import('./debug/containerDebug.js');
}
